import React, { useEffect, useRef } from 'react';
import { StarIcon } from 'lucide-react';
export const TrustpilotReviews = () => {
  const trustboxRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if ((window as any).Trustpilot && trustboxRef.current) {
      ;
      (window as any).Trustpilot.loadFromElement(trustboxRef.current, true);
    }
  }, []);
  return <section className="mb-12" data-id="element-452" data-mp="1fb9qdtub7bi0">
      <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-453" data-mp="ho196b1ccolt">
        Wat cursisten over ons zeggen
      </h2>
      <div ref={trustboxRef} className="trustpilot-widget" data-locale="nl-NL" data-template-id="5419b6ffb0d04a076446a9af" data-businessunit-id="65017f0060003ffc450ac45e" data-style-height="20px" data-style-width="100%" data-theme="light" data-id="element-454" data-mp="mmuli04w69ke">
        <a href="https://nl.trustpilot.com/review/stresslessdogs.nl" target="_blank" rel="noopener noreferrer" data-id="element-455" data-mp="3v3fpf2io2cgn">
          Trustpilot
        </a>
      </div>
    </section>;
};